(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abandoned-cart-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SESSION_KEY = 'abandoned-cart-popup:session';
    const DEADLINE_KEY = 'abandoned-cart-popup:deadline';
    const SHOWN_KEY = 'abandoned-cart-popup:shown';
    const CHECKOUT_KEY = 'abandoned-cart-popup:checkout';

    function storageGet(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function storageSet(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (error) {}
    }

    function storageRemove(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {}
    }

    function allowPopupClicks(drawer) {
      if (!drawer || drawer.dataset.abandonedCartClicks === 'true') return;
      if (typeof drawer.hideForOutsideClickTarget !== 'function' || typeof drawer.allowOutsideClickForTarget !== 'function') return;
      drawer.dataset.abandonedCartClicks = 'true';

      const inPopup = (target) => target instanceof Element && Boolean(target.closest('.abandoned-cart-popup'));
      const originalHide = drawer.hideForOutsideClickTarget.bind(drawer);
      const originalAllow = drawer.allowOutsideClickForTarget.bind(drawer);

      drawer.hideForOutsideClickTarget = (target) => inPopup(target) ? false : originalHide(target);
      drawer.allowOutsideClickForTarget = (target) => inPopup(target) ? true : originalAllow(target);
    }

    function requestUrl(input) {
      if (typeof input === 'string') return input;
      if (input && typeof input.url === 'string') return input.url;
      return '';
    }

    if (!window.__abandonedCartAddHook) {
      window.__abandonedCartAddHook = true;
      const originalFetch = window.fetch.bind(window);

      window.fetch = function (input, init) {
        const pending = originalFetch(input, init);

        try {
          const url = requestUrl(input);
          const body = init && init.body;
          const automaticGift = typeof body === 'string' && (body.indexOf('_gwp') !== -1 || body.indexOf('_abandoned_cart_gift') !== -1);

          if (url.indexOf('/cart/add') !== -1 && !automaticGift) {
            pending.then((response) => {
              if (response && response.ok) {
                document.dispatchEvent(new CustomEvent('abandoned-cart:added'));
              }
            }).catch(function () {});
          }
        } catch (error) {}

        return pending;
      };
    }

    function initAbandonedCartPopup(popup) {
      function hashMatches() {
        const configured = (popup.dataset.triggerHash || '').replace(/^#/, '').trim().toLowerCase();
        if (!configured) return false;
        return (window.location.hash || '').replace(/^#/, '').trim().toLowerCase() === configured;
      }

      if (window.Shopify && Shopify.designMode && popup.dataset.forceVisible !== 'true' && !hashMatches()) return;

      let cartCount = Number.parseInt(popup.dataset.cartCount || '0', 10);
      if (Number.isNaN(cartCount)) cartCount = 0;

      let cartTotal = Number.parseInt(popup.dataset.cartTotal || '0', 10);
      if (Number.isNaN(cartTotal)) cartTotal = 0;

      let productTypes = (popup.dataset.cartProductTypes || '').split('||');
      const minimumTotal = popup.dataset.minimumTotal == null || popup.dataset.minimumTotal === ''
        ? null
        : Number.parseInt(popup.dataset.minimumTotal, 10);
      const requiredType = (popup.dataset.requiredProductType || '').trim().toLowerCase();

      const delaySeconds = Number.parseInt(popup.dataset.delay || '1', 10);
      const delayMs = (Number.isNaN(delaySeconds) ? 1 : delaySeconds) * 1000;
      let timerId = 0;
      let revealPending = false;

      function cartMatches() {
        if (cartCount < 1) return false;
        if (minimumTotal != null && !Number.isNaN(minimumTotal) && minimumTotal > 0 && cartTotal < minimumTotal) return false;
        if (requiredType) {
          const hasType = productTypes.some((type) => type.trim().toLowerCase() === requiredType);
          if (!hasType) return false;
        }
        return true;
      }

      function syncCart(cart) {
        if (!cart) return;
        if (cart.item_count != null) {
          const nextCount = Number(cart.item_count);
          if (!Number.isNaN(nextCount)) cartCount = nextCount;
        }
        if (cart.total_price != null) {
          const nextTotal = Number(cart.total_price);
          if (!Number.isNaN(nextTotal)) cartTotal = nextTotal;
        }
        if (Array.isArray(cart.items)) {
          productTypes = cart.items.map((item) => item.product_type || '');
        }
      }

      function refreshCart() {
        const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((response) => response.ok ? response.json() : null)
          .then((cart) => {
            syncCart(cart);
          })
          .catch(function () {});
      }

      function clearTimer() {
        if (timerId) window.clearTimeout(timerId);
        timerId = 0;
      }

      function alreadyShown() {
        return storageGet(SHOWN_KEY) === '1';
      }

      function wentToCheckout() {
        return storageGet(CHECKOUT_KEY) === '1';
      }

      function markShown() {
        storageSet(SHOWN_KEY, '1');
        storageRemove(DEADLINE_KEY);
        clearTimer();
      }

      function markPopupTriggered() {
        window.abandonedCartPopupTriggered = 1;
        if (document.cookie.indexOf('abandonedCartPopupTriggered=1') === -1) {
          document.cookie = 'abandonedCartPopupTriggered=1; path=/; SameSite=Lax';
        }
        window._conv_q = window._conv_q || [];
        window._conv_q.push({ what: 'run' });
      }

      function qualifyConvert(reason) {
        const returnSet = document.cookie.indexOf('abandonedCartPopupReturn=1') > -1;
        const delaySet = document.cookie.indexOf('abandonedCartPopupDelay=1') > -1;
        if ((reason === 'return' || reason === 'delay') && !returnSet && !delaySet) {
          const name = reason === 'return' ? 'abandonedCartPopupReturn' : 'abandonedCartPopupDelay';
          window[name] = 1;
          document.cookie = name + '=1; path=/; SameSite=Lax';
        }
        markPopupTriggered();
      }

      function isAttentive() {
        return popup.dataset.contentType === 'attentive';
      }

      function isVisible() {
        if (isAttentive()) return popup.dataset.attentiveActive === 'true';
        return popup.hasAttribute('open');
      }

      function attentiveNodes() {
        return document.querySelectorAll('#attentive_overlay, #attentive_creative');
      }

      function attentiveCreativeOpen() {
        return Array.from(attentiveNodes()).some((node) => {
          if (!node.isConnected || node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
          const style = window.getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
          const rect = node.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        });
      }

      function releaseAbandonedCartAttentiveHold() {
        window.abandonedCartAttentiveHold = false;
        window.abandonedCartAttentiveCreativeSeen = false;
        popup.dataset.attentiveActive = 'false';
        if (window.abandonedCartAttentiveCloseObserver) {
          window.abandonedCartAttentiveCloseObserver.disconnect();
          window.abandonedCartAttentiveCloseObserver = null;
        }
        if (window.abandonedCartAttentiveObserver) {
          window.abandonedCartAttentiveObserver.disconnect();
          window.abandonedCartAttentiveObserver = null;
        }
      }

      function holdOtherAttentiveTriggers(allowedId) {
        window.abandonedCartAttentiveHold = true;
        window.abandonedCartAttentiveAllowedId = allowedId || 0;
        if (!window.__attentive || typeof window.__attentive.trigger !== 'function' || window.__attentive.trigger.__abandonedCartHold) return;
        const original = window.__attentive.trigger.bind(window.__attentive);
        function wrapped(filter, clientId, email, creativeId) {
          if (window.abandonedCartAttentiveUserTrigger) {
            window.abandonedCartAttentiveUserTrigger = false;
            releaseAbandonedCartAttentiveHold();
            if (popup.hasAttribute('open') && typeof popup.hide === 'function') popup.hide();
            return original(filter, clientId, email, creativeId);
          }
          if (window.abandonedCartAttentiveHold && Number(creativeId) !== Number(window.abandonedCartAttentiveAllowedId)) {
            if (!window.abandonedCartAttentiveCreativeSeen || attentiveCreativeOpen()) return;
            releaseAbandonedCartAttentiveHold();
          }
          return original(filter, clientId, email, creativeId);
        }
        wrapped.__abandonedCartHold = true;
        window.__attentive.trigger = wrapped;
      }

      function watchAbandonedCartAttentiveClose() {
        window.abandonedCartAttentiveCreativeSeen = false;
        if (window.abandonedCartAttentiveCloseObserver) {
          window.abandonedCartAttentiveCloseObserver.disconnect();
        }

        const observedNodes = new WeakSet();
        let releaseTimer = 0;
        let considerTimer = 0;

        const consider = () => {
          if (!window.abandonedCartAttentiveHold) return;
          if (attentiveCreativeOpen()) {
            window.abandonedCartAttentiveCreativeSeen = true;
            window.clearTimeout(releaseTimer);
            attentiveNodes().forEach((node) => {
              if (observedNodes.has(node)) return;
              observedNodes.add(node);
              observer.observe(node, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
            });
            return;
          }
          if (!window.abandonedCartAttentiveCreativeSeen) return;
          window.clearTimeout(releaseTimer);
          releaseTimer = window.setTimeout(() => {
            if (!window.abandonedCartAttentiveHold || attentiveCreativeOpen()) return;
            releaseAbandonedCartAttentiveHold();
          }, 300);
        };

        const observer = new MutationObserver(() => {
          if (!window.abandonedCartAttentiveHold) return;
          window.clearTimeout(considerTimer);
          considerTimer = window.setTimeout(consider, 50);
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
        window.abandonedCartAttentiveCloseObserver = observer;
        consider();
      }

      function suppressOtherAttentive(allowedId) {
        holdOtherAttentiveTriggers(allowedId);
        attentiveNodes().forEach((node) => node.remove());
        if (allowedId || window.abandonedCartAttentiveObserver) return;

        const observer = new MutationObserver(() => {
          if (!window.abandonedCartAttentiveHold) return;
          attentiveNodes().forEach((node) => node.remove());
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
        window.abandonedCartAttentiveObserver = observer;
        popup.addEventListener('dialog:after-hide', () => {
          window.abandonedCartAttentiveHold = false;
          observer.disconnect();
          window.abandonedCartAttentiveObserver = null;
        }, { once: true });
      }

      function presentAttentive(attempt, reason) {
        if (window.bfcmAttentiveCtaOnly) return;
        if (attempt === 0) {
          if (popup.dataset.attentiveActive === 'true') return;
          popup.dataset.attentiveActive = 'true';
        }

        const ready = window.__attentive && typeof window.__attentive.trigger === 'function';
        if (!ready) {
          if (attempt < 40) {
            window.setTimeout(() => presentAttentive(attempt + 1, reason), 250);
            return;
          }
          popup.dataset.attentiveActive = 'false';
          return;
        }

        const desktopId = Number(popup.dataset.attentiveDesktopId);
        const mobileId = Number(popup.dataset.attentiveMobileId);
        const id = window.innerWidth >= 760 ? desktopId : mobileId;
        if (!id) {
          popup.dataset.attentiveActive = 'false';
          return;
        }

        suppressOtherAttentive(id);
        window.__attentive.trigger(null, null, null, id);
        watchAbandonedCartAttentiveClose();
        markShown();
        qualifyConvert(reason);
      }

      function presentCustom(reason) {
        if (!window.bfcmAttentiveCtaOnly) suppressOtherAttentive();
        markShown();
        allowPopupClicks(document.querySelector('cart-drawer'));
        if (popup.parentElement !== document.body) document.body.append(popup);
        if (typeof popup.show === 'function') popup.show();
        qualifyConvert(reason);
      }

      function reveal(reason) {
        if (isVisible()) {
          clearTimer();
          storageRemove(DEADLINE_KEY);
          return;
        }
        if (alreadyShown() || wentToCheckout() || revealPending) return;
        revealPending = true;

        refreshCart().then(() => {
          revealPending = false;
          if (isVisible()) {
            clearTimer();
            storageRemove(DEADLINE_KEY);
            return;
          }
          if (alreadyShown() || wentToCheckout() || !cartMatches()) {
            clearTimer();
            storageRemove(DEADLINE_KEY);
            return;
          }

          if (isAttentive()) {
            presentAttentive(0, reason);
            return;
          }

          presentCustom(reason);
        });
      }

      function arm(fromNow) {
        if (isVisible() || alreadyShown() || cartCount < 1) return;

        const deadline = fromNow ? Date.now() + delayMs : Number(storageGet(DEADLINE_KEY) || 0);
        if (!deadline) return;

        storageSet(DEADLINE_KEY, String(deadline));
        clearTimer();
        timerId = window.setTimeout(() => reveal('delay'), Math.max(deadline - Date.now(), 0));
      }

      function onAdd() {
        if (isVisible()) return;
        storageRemove(CHECKOUT_KEY);
        if (cartCount < 1) cartCount = 1;
        arm(true);
      }

      document.addEventListener('cart:change', (event) => {
        const cart = event.detail && event.detail.cart;
        if (!cart || cart.item_count == null) return;

        syncCart(cart);

        if (cartCount < 1) {
          clearTimer();
          storageRemove(DEADLINE_KEY);
          return;
        }

        if (event.detail.baseEvent === 'variant:add') onAdd();
      });

      document.addEventListener('abandoned-cart:added', onAdd);

      document.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target || !target.closest('.black-friday-btn')) return;
        window.abandonedCartAttentiveUserTrigger = true;
        window.setTimeout(() => {
          window.abandonedCartAttentiveUserTrigger = false;
        }, 0);
      }, true);

      document.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (!target.closest('[name="checkout"], a[href*="/checkout"]')) return;

        clearTimer();
        storageRemove(DEADLINE_KEY);
        storageSet(CHECKOUT_KEY, '1');
      }, true);

      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && popup.hasAttribute('open') && typeof popup.hide === 'function') {
          popup.hide();
        }
      });

      popup.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-abandoned-cart-gift]') : null;
        if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

        const variantId = Number(button.getAttribute('data-abandoned-cart-gift'));
        if (!variantId) return;

        event.preventDefault();
        button.setAttribute('aria-busy', 'true');

        const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: { _abandoned_cart_gift: 'true' } }]
          })
        }).then((response) => {
          if (!response.ok) throw new Error('Unable to add gift');
          return response.json();
        }).then(() => {
          if (popup.dataset.giftCheckout === 'true') {
            clearTimer();
            storageRemove(DEADLINE_KEY);
            storageSet(CHECKOUT_KEY, '1');
            const form = document.createElement('form');
            form.method = 'post';
            form.action = root + 'cart';
            const checkoutInput = document.createElement('input');
            checkoutInput.type = 'hidden';
            checkoutInput.name = 'checkout';
            form.appendChild(checkoutInput);
            document.body.appendChild(form);
            form.submit();
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          const drawer = document.querySelector('cart-drawer');
          popup.style.zIndex = '1';
          if (typeof popup.hide === 'function') popup.hide();
          if (drawer && typeof drawer.show === 'function') drawer.show();
        }).catch(function () {}).then(() => {
          button.setAttribute('aria-busy', 'false');
        });
      });

      function openNow() {
        if (isVisible()) return;
        if (isAttentive()) {
          presentAttentive(0);
          return;
        }
        if (!window.bfcmAttentiveCtaOnly) suppressOtherAttentive();
        allowPopupClicks(document.querySelector('cart-drawer'));
        if (popup.parentElement !== document.body) document.body.append(popup);
        if (typeof popup.show === 'function') popup.show();
        qualifyConvert();
      }

      if (hashMatches()) openNow();

      window.addEventListener('hashchange', () => {
        if (hashMatches()) openNow();
      });

      if (popup.dataset.forceVisible === 'true') {
        openNow();
        return;
      }

      const isNewSession = storageGet(SESSION_KEY) !== '1';
      storageSet(SESSION_KEY, '1');

      if (isNewSession && cartCount > 0 && cartMatches()) {
        window.setTimeout(() => reveal('return'), 500);
      } else if (!wentToCheckout() && storageGet(DEADLINE_KEY)) {
        arm(false);
      }
    }

    function boot(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('pop-in.abandoned-cart-popup').forEach((popup) => {
        if (popup.dataset.bound === 'true') return;
        popup.dataset.bound = 'true';
        customElements.whenDefined('pop-in').then(() => initAbandonedCartPopup(popup));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document));
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
